import Vue from 'vue'
import Router from 'vue-router'
import store from './store/store.js'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'login',
      component: () => import('./modules/login/Login.vue')
    },
    {
      path: '/',
      component: () => import('./layout/Layout.vue'),
      children: [
        {
          path: '/dashboard',
          name: 'dashboard',
          component: () => import('./modules/dashboard/Dashboard.vue')
        },
        // <<< INI alugueis
        {
          path: '/alugueis',
          component: () => import('./modules/alugueis/Alugueis.vue'),
          children: [
            {
              path: '',
              name: 'alugueisContratos',
              component: () => import('./modules/alugueis/contratos/Contratos.vue')
            },
            {
              name: 'alugueisClientes',
              path: 'clientes',
              component: () => import('./modules/alugueis/clientes/Clientes.vue')
            },
            {
              name: 'alugueisImoveis',
              path: 'imoveis',
              component: () => import('./modules/alugueis/imoveis/Imoveis.vue')
            },
            {
              name: 'baixasAlugueis',
              path: 'baixasAlugueis',
              component: () => import('./modules/alugueis/baixas/alugueis/BaixasAlugueis.vue')
            },
            {
              name: 'baixasRetornoBancario',
              path: 'baixasRetornoBancario',
              component: () => import('./modules/alugueis/baixas/retornoBancario/BaixasRetornoBancario.vue')
            },
            {
              name: 'baixasRepasses',
              path: 'baixasRepasses',
              component: () => import('./modules/alugueis/baixas/repasses/BaixasRepasses.vue')
            },
            {
              name: 'remessasBancarias',
              path: 'remessasBancarias',
              component: () => import('./modules/alugueis/remessasRegistros/remessas/RemessasBancarias.vue')
            },
            {
              name: 'registrosApi',
              path: 'registrosApi',
              component: () => import('./modules/alugueis/remessasRegistros/registrosApi/registro/RegistrosApi.vue')
            },
            {
              name: 'controleRegistroApi',
              path: 'controleRegistroApi',
              component: () => import('./modules/alugueis/remessasRegistros/registrosApi/controle/ControleRegistroApi.vue')
            },
            {
              name: 'dimob',
              path: 'dimob',
              component: () => import('./modules/alugueis/dimob/Dimob.vue')
            },
            {
              name: 'vistorias',
              path: 'vistorias',
              component: () => import('./modules/alugueis/vistorias/Vistorias.vue')
            }
          ]
        },
        {
          name: 'parcerias',
          path: 'parcerias',
          component: () => import('./modules/parcerias/Parcerias.vue')
        },
        // >>> FIM alugueis
        {
          path: '/clientes',
          name: 'clientes',
          component: () => import('./modules/vendas/clientes/Clientes.vue')
        },
        {
          path: '/imoveis',
          name: 'imoveis',
          component: () => import('./modules/vendas/imoveis/Imoveis.vue')
        },
        {
          path: '/vendas',
          name: 'vendas',
          component: () => import('./modules/vendas/contratos/Contratos.vue')
        },
        {
          path: '/site',
          name: 'site',
          component: () => import('./modules/site/Site.vue')
        },
        {
          path: '/atendimentos',
          name: 'atendimentos',
          component: () => import('./modules/vendas/atendimentos/Atendimentos.vue') 
        },
        {
          path: '/historicoCobranca',
          name: 'historicoCobranca',
          component: () => import('./modules/historicoCobranca/HistoricoDeCobranca.vue') 
        },
        {
          path: '/financeiro',
          component: () => import('./modules/financeiro/Financeiro.vue'),
          children: [
            {
              path: 'contasReceber',
              name: 'financeiroContasReceber',
              component: () => import('./modules/financeiro/contasReceber/ContasReceber.vue')
            },
            {
              path: 'contasPagar',
              name: 'financeiroContasPagar',
              component: () => import('./modules/financeiro/contasPagar/ContasPagar.vue')
            },
            {
              path: 'fornecedores',
              name: 'financeiroFornecedores',
              component: () => import('./modules/financeiro/fornecedores/Fornecedores.vue')
            },
            {
              path: 'planosConta',
              name: 'financeiroPlanosConta',
              component: () => import('./modules/financeiro/planosConta/PlanosConta.vue')
            },
            {
              path: 'gruposConta',
              name: 'financeiroGruposConta',
              component: () => import('./modules/financeiro/gruposConta/GruposConta.vue')
            },
            {
              path: 'subGruposConta',
              name: 'financeiroSubGruposConta',
              component: () => import('./modules/financeiro/subGrupoConta/SubGrupoPlanoContas.vue')
            },
            {
              path: 'tiposConta',
              name: 'financeiroTiposConta',
              component: () => import('./modules/financeiro/tiposConta/TipoContas.vue')
            },
            {
              path: 'remessasBancarias',
              name: 'financeiroRemessasBancarias',
              component: () => import('./modules/financeiro/remessasBancariasFinanceiro/RemessaBancariaFinanceiro.vue')
            },
            {
              path: 'retornoBancario',
              name: 'financeiroRetornoBancario',
              component: () => import('./modules/financeiro/baixaRetornoBancario/RetornoBancarioFinanceiro.vue')
            }
          ]
        },
        {
          path: '/configuracoes',
          component: () => import('./modules/configuracoes/Configuracoes.vue'),
          children: [
            {
              path: 'administradoras',
              name: 'configuracoesAdministradoras',
              component: () => import('./modules/configuracoes/administradoras/Administradoras.vue')
            },
            {
              path: 'condominios',
              name: 'configuracoesCondominios',
              component: () => import('./modules/configuracoes/condominios/Condominios.vue')
            },
            {
              path: 'contas-bancarias',
              name: 'configuracoesContasBancarias',
              component: () => import('./modules/configuracoes/contas_bancarias/ContasBancarias.vue')
            },
            {
              path: 'placas',
              name: 'configuracoesPlacas',
              component: () => import('./modules/configuracoes/placas/Placas.vue')
            },
            {
              path: 'parametros',
              name: 'configuracoesParametros',
              component: () => import('./modules/configuracoes/parametros/Parametros.vue')
            },
            {
              path: 'logs-acesso',
              name: 'configuracoesLogsDeAcesso',
              component: () => import('./modules/configuracoes/logs_de_acesso/LogsAcesso.vue')
            },
            {
              path: 'portais',
              name: 'configuracoesPortais',
              component: () => import('./modules/configuracoes/portais/Portais.vue')
            },
            {
              path: 'rede-imob',
              name: 'configuracoesRedeImob',
              component: () => import('./modules/configuracoes/rede_imob/RedeImob.vue')
            },
            {
              path: 'perfis-usuario',
              name: 'configuracoesPerfisUsuario',
              component: () => import('./modules/configuracoes/perfis_usuarios/Perfis.vue')
            },
            {
              path: 'usuarios',
              name: 'configuracoesUsuarios',
              component: () => import('./modules/configuracoes/usuarios/Usuarios.vue')
            },
            {
              path: 'formularios',
              name: 'configuracoesFormularios',
              component: () => import('./modules/configuracoes/formularios/Formularios.vue')
            },
            {
              path: 'assinaturaEletronica',
              name: 'configuracoesAssinaturaEletronica',
              component: () => import('./modules/configuracoes/assinaturaEletronica/AssinaturaEletronica.vue')
            },
            {
              path: 'site',
              name: 'configuracoesSite',
              component: () => import('./modules/configuracoes/site/Site.vue')
            }
          ]
        },
        {
          path: '/caixa',
          name: 'caixa',
          component: () => import('./modules/caixa/Caixa.vue')
        }
      ]
    },
    { 
      path: '*',
      redirect: '/'
    }
  ]
})

router.beforeEach((to, from, next) => {
  if(to.path == "/") { next(); return; }

  if(store.state.loginStore.usuarioLogado && store.state.loginStore.usuarioLogado.permissoes) {
    next();
  } else {
    next("/");
  }
});

export default router;